import { render } from "./CategoryDialogCard.vue?vue&type=template&id=e2df60d0&scoped=true"
import script from "./CategoryDialogCard.vue?vue&type=script&lang=js"
export * from "./CategoryDialogCard.vue?vue&type=script&lang=js"

import "./CategoryDialogCard.vue?vue&type=style&index=0&id=e2df60d0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2df60d0"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBadge,QImg,QCardSection,QSkeleton});
